<template>
  <div>
    <v-select
      v-model="data"
      :items="augmentedItems"
      item-text="displayName"
      item-value="id"
      label="Select SR"
    ></v-select>
  </div>
</template>

<script>
import { axios } from '../utils'

export default {
  props: {
    value: {}
  },
  data() {
    return {
      items: [],
      data: ''
    }
  },
  computed: {
    augmentedItems() {
      // Add a displayName property to each item
      return this.items.map(item => ({
        ...item,
        displayName: `${item.first_name} ${item.last_name}`
      }))
    }
  },
  mounted() {
    this.fetchEmployeeData()
  },
  methods: {
    fetchEmployeeData() {
      console.log(this.data)
      axios
        .get(`api/admin/select-employees`)
        .then(res => {
          this.items = res.data
          console.log(this.items)
        })
        .catch(err => console.log(err))
    }
  },
  watch: {
    data: function(val) {
      this.$emit('input', val)
      console.log(val)
    },
    value: function(newVal) {
      console.log(newVal)
      // Update the data when the prop changes
      this.data = newVal
    }
  }
}
</script>

<style></style>
